var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"platform-font"},[_c('main-app-bar'),_c('v-main',{attrs:{"full-screen":_vm.$root.fullScreenView}},[_c('router-view')],1),_c('main-footer-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }